import React, { useCallback } from 'react'

import { ConfirmationModal } from 'govwell-ui'
import { AIChatFallbackContactFragment } from 'types/graphql'

import { useDeleteAIChatFallbackContactMutation } from 'src/fetch/aiChatFallbackContacts'
import { RefetchFnType } from 'src/types'

type Props = {
  aiChatFallbackContact: AIChatFallbackContactFragment
  onClose: () => void
  refetch: RefetchFnType
}

const DeleteAIChatFallbackContactModal = ({ aiChatFallbackContact, onClose, refetch }: Props) => {
  const { mutateAsync: deleteAIChatFallbackContact } = useDeleteAIChatFallbackContactMutation()

  const handleDelete = useCallback(async () => {
    await deleteAIChatFallbackContact({ id: aiChatFallbackContact.id })
    await refetch()
  }, [deleteAIChatFallbackContact, aiChatFallbackContact.id, refetch])

  return (
    <ConfirmationModal
      title="Delete contact"
      cancelText="Cancel"
      confirmText="Delete contact"
      isDestructive
      onCancel={onClose}
      onConfirm={handleDelete}
    >
      Are you sure you want to delete this contact
      {aiChatFallbackContact.fallbackConditions
        ? ` for "${aiChatFallbackContact.fallbackConditions}"`
        : ''}
      ?
    </ConfirmationModal>
  )
}

export default React.memo(DeleteAIChatFallbackContactModal)
